export const COMETCHAT_CONSTANTS = {
	APP_ID: '237748f750c6dc96',
	REGION: 'us',
	AUTH_KEY: '1ac45f9dea55a53f3311106a686efadb6d5fb844'
}
